import styled from "styled-components";

export const TransportationCompleteModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 36px;

  font-size: 1.6rem;
  text-align: center;

  span {
    white-space: pre-wrap;
    line-height: 1.5;
    font-weight: 500;
    color: #333;
  }
`;

export const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 3px;

  .small {
    width: 40%;
  }
`;
